import './CopiedToast.scss';
import { Toast } from 'react-bootstrap';

interface CopiedToastProps {
  show: boolean;
  onClose: () => void;
  message?: string;
  delay?: number;
}

export const CopiedToast = ({
  show,
  onClose,
  message = 'Copied to clipboard',
  delay = 1500
}: CopiedToastProps) => (
  <Toast className='copied-toast' onClose={onClose} show={show} delay={delay} autohide>
    <Toast.Body>{message}</Toast.Body>
  </Toast>
);
